/**
 * Single formatter for the "SSN or Employee ID" lookup box, shared by the PostIF start screen
 * (src/pages/supervision/PostInterviewForm/start/PifStartScreen.tsx) and the workflow runtime's
 * PIF start stage (src/features/workflows/WorkflowPifStartStage.tsx) so the two screens cannot
 * drift apart. Both the identity lookup SP and the workflow mock directory are keyed on the
 * hyphenated SSN, so an unformatted value reads as "no match" rather than as an error.
 *
 * Employee ID stays plain (≤6 digits); SSN gets XXX-XX-XXXX as digits accumulate past 6.
 */
export const formatIdentityLookupValue = (raw: string): string => {
  const digits = raw.replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 6) return digits;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5, 9)}`;
};
